import { render, staticRenderFns } from "./OzWallListRow.vue?vue&type=template&id=50e466e8&"
import script from "./OzWallListRow.vue?vue&type=script&lang=ts&"
export * from "./OzWallListRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports